import { Breadcrumb } from '@/components/general/BreadCrumb';
import SectionHead from '@/components/general/SectionHead';
import React from 'react';

export default function ContactHero() {
  return (
    <>
      <Breadcrumb items={[{ label: 'خانه', to: '/' }, { label: 'تماس با ما' }]} position="center" />
      <SectionHead
        tag={'در خدمت شما هستیم'}
        title={'تماس با ما'}
        text="اعتماد شما، مهم‌ترین سرمایه ما در کاراست. ما باور داریم که یک تجربه دیجیتال موفق، تنها با پشتیبانی واقعی و مداوم ممکن می‌شود؛ جایی که کاربر حس کند همیشه همراه و شنیده می‌شود.

فرقی نمی‌کند چه سؤالی دارید، یا در کجای مسیر به کمک نیاز دارید — ما در کنارتان هستیم.

از اولین کلیک روی سایت تا لحظه‌ای که مشکلتان به‌طور کامل حل شود، تیم ما در کنار شماست تا اطمینان حاصل کند تجربه‌تان دقیق، ساده و قابل اعتماد باشد."
        headingTag="h1"
        type="otherPages"
        position={'center'}
      />
    </>
  );
}
